import React from 'react';
import styled from 'styled-components';
import clearFieldIcon from 'assets/icons/clear-field.svg';
import { colours } from 'styling/colours';

const StyledButton = styled.button`
  background: transparent;
  outline: none;
  border: none;
  &:hover {
    cursor: pointer;
  }
  &:disabled {
    cursor: not-allowed;
  }
  &:focus-visible {
    outline: 1px solid ${colours.secondary};
  }
`;

type ClearInputButtonTypes = {
  onClick: (arg: any) => void;
  searchInProgress?: boolean;
};
export default function ClearInputButton({ onClick, searchInProgress }: ClearInputButtonTypes) {
  return (
    <StyledButton
      id='clear-button'
      tabIndex={0}
      disabled={searchInProgress}
      onClick={(e) => onClick(e)}
      className="clear-input-button"
    >
      <img src={clearFieldIcon} alt="clear" />
    </StyledButton>
  );
}
